import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlus = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.25 7.74995H1.25C1.0375 7.74995 0.859375 7.67805 0.715625 7.53425C0.571875 7.39043 0.5 7.21223 0.5 6.99965C0.5 6.78705 0.571875 6.60896 0.715625 6.46538C0.859375 6.32179 1.0375 6.25 1.25 6.25H6.25V1.25C6.25 1.0375 6.3219 0.859375 6.4657 0.715625C6.60952 0.571875 6.78772 0.5 7.0003 0.5C7.2129 0.5 7.39099 0.571875 7.53457 0.715625C7.67816 0.859375 7.74995 1.0375 7.74995 1.25V6.25H12.75C12.9625 6.25 13.1406 6.3219 13.2843 6.4657C13.4281 6.60952 13.5 6.78772 13.5 7.0003C13.5 7.2129 13.4281 7.39099 13.2843 7.53458C13.1406 7.67816 12.9625 7.74995 12.75 7.74995H7.74995V12.75C7.74995 12.9625 7.67805 13.1406 7.53425 13.2843C7.39043 13.4281 7.21223 13.5 6.99965 13.5C6.78705 13.5 6.60896 13.4281 6.46537 13.2843C6.32179 13.1406 6.25 12.9625 6.25 12.75V7.74995Z",
		fill: "#1B1B1B"
	})
});
export default SvgPlus;
